<template>
  <div class="box">
    <no-results
      :title="`Site unavailable`"
      :message="message"
      :cta="{ label: 'Go back', class: 'is-outlined', icon: 'arrow-left' }"
      icon="exclamation-triangle"
      @click="$router.go(-1)"
    />
  </div>
</template>

<script>
export default {
  name: "SiteUnavailableModal",
  props: {
    site: {
      type: Object,
      required: true
    },
    email: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    message() {
      return (
        "This site is currently unavailable. Please " +
        (this.email ? `email ${this.email} ` : "get in touch ") +
        "so we can promptly resolve this for you."
      );
    }
  }
};
</script>
